(function () {
	'use strict';

	angular.module('dcApp').component('projectVersionsList', {
		bindings: {
			projectId: '<',
		},
		controller: [
			'$scope',
			'$rootScope',
			'$q',
			'ProjectService',
			'ModalService',
			'AppSelectorService',
			'toaster',
			'gettextCatalog',
			'PAGINATIONS_SIZE',
			'PAGINATIONS_SIZES',
			ProjectVersionsListController,
		],
		controllerAs: 'vm',
		templateUrl:
			'directives/project/project-versions-list/project-versions-list.html',
	});

	// --- Controller Function ---
	function ProjectVersionsListController(
		$scope,
		$rootScope,
		$q,
		ProjectService,
		ModalService,
		AppSelectorService,
		toaster,
		gettextCatalog,
		PAGINATIONS_SIZE,
		PAGINATIONS_SIZES
	) {
		var vm = this;

		// --- Component Properties ---
		vm.projectVersions = [];
		vm.showProjectGrid = false;
		vm.toasterPopSuccess = gettextCatalog.getString('Succès');
		vm.getGridData = getGridData;
		vm.activateVersion = activateVersion;
		vm.toggleVersionAvailability = toggleVersionAvailability;
		vm.refreshProjectVersions = refreshProjectVersions;
		vm.deleteProject = deleteProject;
		vm.configureVersion = configureVersion;
		vm.shareVersionElements = shareVersionElements;

		vm.actionsHelpVisible = false;
		vm.actionsHelpPopover = {
			target: '#project-version-actions-help',
			showEvent: 'dxclick',
			position: 'bottom',
			width: 420,
			bindingOptions: {
				visible: 'vm.actionsHelpVisible',
			},
			wrapperAttr: {
				class: 'project-version-actions-help',
			},
		};

		vm.$onInit = function () {
			vm.getGridData();
		};

		// --- Private Functions ---

		function getGridData() {
			vm.showProjectGrid = false;
			ProjectService.getProjectDetailedVersions(vm.projectId).then(function (
				response
			) {
				if (response.data !== undefined) {
					let selectedVersion = AppSelectorService.getSelectedProjectVersion();
					vm.projectVersions = response.data.map(function (version) {
						return {
							id: version.id,
							uuid: version.uuid,
							version: version.version,
							versionDescription: version.version_description,
							isDefaultVersion: version.is_default_version,
							isVersionAvailable: version.is_available,
							isSelectedVersion:
								selectedVersion !== null &&
								selectedVersion !== undefined &&
								String(version.version) === String(selectedVersion),
							projectLabel: version.project_label,
						};
					});
					vm.dataGridOptions.dataSource = vm.projectVersions;
					vm.showProjectGrid = true;
				}
			});
		}

		function activateVersion(version) {
			if (!version.isDefaultVersion) {
				ProjectService.activateProjectVersion(version.id).then(function (
					response
				) {
					toaster.pop(
						'success',
						vm.toasterPopSuccess,
						gettextCatalog.getString('project.version.activate.success.message')
					);
					vm.refreshProjectVersions();
				});
			}
		}

		function toggleVersionAvailability(v) {
			ModalService.confirm({
				title: v.isVersionAvailable
					? gettextCatalog.getString(
							'modal.confirm.project.version.list.makeUnavailable.title',
							{ version: v.version }
					  )
					: gettextCatalog.getString(
							'modal.confirm.project.version.list.makeAvailable.title',
							{ version: v.version }
					  ),
				content: v.isVersionAvailable
					? gettextCatalog.getString(
							'modal.confirm.project.version.list.makeUnavailable.message',
							{ version: v.version }
					  )
					: gettextCatalog.getString(
							'modal.confirm.project.version.list.makeAvailable.message',
							{ version: v.version }
					  ),
				acceptLabel: v.isVersionAvailable
					? gettextCatalog.getString(
							'modal.confirm.project.version.list.makeUnavailable.accept.label'
					  )
					: gettextCatalog.getString(
							'modal.confirm.project.version.list.makeAvailable.accept.label'
					  ),
				cancelLabel: gettextCatalog.getString(
					'modal.confirm.project.version.list.availability.cancel.label'
				),
			}).then(function () {
				applyVersionAvailability(v);
			});
		}

		// The flag the row is showing is the one before the click, so the call is its opposite.
		function applyVersionAvailability(v) {
			var call = v.isVersionAvailable
				? ProjectService.makeProjectVersionUnavailable
				: ProjectService.makeProjectVersionAvailable;
			var message = v.isVersionAvailable
				? 'project.version.availability.unavailable.success.message'
				: 'project.version.availability.available.success.message';

			call(v.id).then(function () {
				toaster.pop(
					'success',
					vm.toasterPopSuccess,
					gettextCatalog.getString(message)
				);
				vm.refreshProjectVersions();
			});
		}

		function refreshProjectVersions() {
			vm.showProjectGrid = false;
			setTimeout(function () {
				$scope.$apply(function () {
					vm.getGridData();
				});
			}, 10);
		}

		function deleteProject(version) {
			let deleteProjectModalParams = {
				moduleName: 'deleteProject',
				modalName: 'deleteProject',
				controllerName: 'DeleteProjectController',
				dependencies: {
					title:
						gettextCatalog.getString('Suppression du projet') +
						': ' +
						`${version.projectLabel}-V${version.version}`,
					projectId: version.id,
					projectName: `${version.projectLabel}-V${version.version}`,
				},
			};
			openModal(deleteProjectModalParams);
		}

		/**
		 * Configuration (numéro, description, contextes) de la version active.
		 */
		function configureVersion(version) {
			openModal({
				moduleName: 'versionConfiguration',
				modalName: 'versionConfigurationModal',
				controllerName: 'VersionConfigurationModalController',
				dependencies: {
					versionId: version.id,
					versionLabel: version.projectLabel
						? version.projectLabel
						: version.version,
					versionNumber: version.version,
				},
			}).then(
				function () {
					vm.refreshProjectVersions();
				},
				function () {}
			);
		}

		/**
		 * Partage des éléments de la version active.
		 */
		function shareVersionElements(version) {
			openModal({
				moduleName: 'versionElementsSharing',
				modalName: 'versionElementsSharingModal',
				controllerName: 'VersionElementsSharingModalController',
				dependencies: {
					versionId: version.id,
					versionLabel: version.projectLabel
						? version.projectLabel
						: version.version,
					versionNumber: version.version,
				},
			});
		}

		function openModal(modalParams) {
			if (!modalParams.modalName || !modalParams.controllerName) {
				return $q.reject();
			}
			return ModalService.open({
				controllerAs: 'vm',
				bindToController: true,
				templateUrl:
					'./src/components/modules/project/' +
					modalParams.moduleName +
					'/' +
					modalParams.modalName +
					'.html',
				controller: modalParams.controllerName,
				disableBackdrop: true,
				locals: modalParams.dependencies ? modalParams.dependencies : undefined,
			});
		}

		// --- Grid Configuration ---
		vm.dataGridOptions = {
			dataSource: [],
			paging: {
				enabled: true,
				pageSize: PAGINATIONS_SIZE,
			},
			pager: {
				showPageSizeSelector: true,
				allowedPageSizes: PAGINATIONS_SIZES,
				infoText: $rootScope.dataGirdCaptionsTra['pager'],
				showInfo: true,
				visible: true,
			},
			scrolling: {
				rowRenderingMode: 'Standard',
				showScrollbar: 'onHover',
			},
			searchPanel: { visible: true, width: 240 },
			filterRow: { visible: true, applyFilter: 'auto' },
			rowAlternationEnabled: true,
			filterPanel: { visible: true },
			headerFilter: { visible: true, applyFilter: 'auto' },
			showColumnLines: true,
			showRowLines: false,
			allowColumnReordering: true,
			allowColumnResizing: true,
			columnAutoWidth: true,
			showBorders: true,
			columns: [
				{
					dataField: 'version',
					caption: gettextCatalog.getString(
						'project.edit.versions.grid.version'
					),
					cellTemplate: 'versionLabelTemplate',
				},
				{
					dataField: 'versionDescription',
					caption: gettextCatalog.getString(
						'project.edit.versions.grid.description'
					),
				},
				{
					dataField: 'isDefaultVersion',
					width: '150px',
					caption: gettextCatalog.getString(
						'project.edit.versions.grid.active'
					),
					cellTemplate: 'isActiveTemplate',
				},
				{
					dataField: 'isVersionAvailable',
					width: '150px',
					caption: gettextCatalog.getString(
						'project.edit.versions.grid.isAvailable'
					),
					cellTemplate: 'isAvailableTemplate',
				},
				{
					caption: gettextCatalog.getString(
						'project.edit.versions.grid.actions'
					),
					fixed: true,
					fixedPosition: 'right',
					width: '200px',
					cellTemplate: 'actionsTemplate',
				},
			],
		};
	}
})();
